export const SET_LOADING = '[APP] SET LOADING';
export const SET_LANGUAGE = '[APP] SET LANGUAGE';

export const setLoading = (value) => {
    return (dispatch, getState) => {
        dispatch({ type: SET_LOADING, value: value });
    };
};

export const setLanguage = (value) => {
    return (dispatch, getState) => {
        dispatch({ type: SET_LANGUAGE, value: value });
    };
};

export function mapGeneralDispatchToProps(dispatch) {
    return {
        setLoading: (value) => {
            dispatch(setLoading(value));
        },
        setLanguage: (value) => {
            dispatch(setLanguage(value));
        },
    };
}
